import startSearchWithRefiners from './searchRefiners/startSearchWithRefiners';
import { onScopeRefinerChanged } from '../actions/internalActions';
import { setStaticSearchScope } from '../actions/publicActions';
import ScopeOption from '../store/schema/ScopeOption';
import { getStore } from '../store/store';
import { logUsage } from 'owa-analytics';
import { orchestrator } from 'satcheljs';
import { SearchScopeKind } from 'owa-search-service';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

export default orchestrator(onScopeRefinerChanged, async actionMessage => {
    const scopeOption: ScopeOption = actionMessage.scopeOption;

    // Track previous scope for instrumentation.
    const previousScope = getStore().staticSearchScope;

    // Change folder scope.
    setStaticSearchScope(scopeOption.searchScope);

    // Get current scope (what we just set).
    const currentScope = getStore().staticSearchScope;

    // Log folder scope change if (scopes are folders).
    if (
        (previousScope.kind === SearchScopeKind.PrimaryMailbox &&
            currentScope.kind === SearchScopeKind.PrimaryMailbox) ||
        (previousScope.kind === SearchScopeKind.ArchiveMailbox &&
            currentScope.kind === SearchScopeKind.ArchiveMailbox)
    ) {
        logUsage('Search_RefinerFolderScopeChanged', [
            folderIdToName(previousScope.folderId),
            folderIdToName(currentScope.folderId),
            currentScope.kind,
        ]);
    }

    // Start search.
    startSearchWithRefiners();
});
